/**
 * @author        yontaek@agileengine.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   Marker constants
 */

export const VISITED_Z_INDEX = 0
export const CLUSTER_Z_INDEX = 10
export const MARKER_Z_INDEX = 20
export const CITY_Z_INDEX = 20
export const FAVORITED_Z_INDEX = 40
export const FEATURED_Z_INDEX = 60
export const LABEL_Z_INDEX = 60
export const SELECTED_Z_INDEX = 80
export const HOVER_Z_INDEX = 100
export const CITY_HOVER_Z_INDEX = 100
export const VISITED_HOVER_Z_INDEX = 120

export const BUILDING_MARKER = 'BUILDING_MARKER'
export const CITY_MARKER = 'CITY_MARKER'
export const RENTABLE_MARKER = 'RENTABLE_MARKER'
export const PIN_MARKER = 'PIN_MARKER'

export const ANALYTIC_CHANNEL = 'Markers'
export const EVENT_OPENED = 'Opened'
